import * as _ from "lodash";
import {BaseDashboardWidgetView, BaseDashboardWidgetViewOptions} from "../../../dashboard/widgets/_BaseWidgetView";

export class TextWidgetView extends BaseDashboardWidgetView {

    protected template = _.template(require('templates/reports/widgets/textwidget/textwidget.html'));

    constructor(options: BaseDashboardWidgetViewOptions) {
        super(<any> _.merge({
            tagName: "div",
            className: 'widget widget-w-6',
            events: {
                // Widget related buttons
                'click .w-settings .remove': 'handleRemoveWidgetClick',
                'click .w-delete-widget .w-cancel': 'handleRemoveWidgetCancelClick',
                'click .w-delete-widget .w-confirm': 'handleRemoveWidgetConfirmClick',
                'click .w-settings .gear': 'handleEditWidgetClick',
                'click .w-settings .clone': 'handleCloneWidget'
            }
        }, options));
    }

    render() {
        this.$el.html(this.template({
            reportId: this.options.report.get('id'),
            permissionCollection: this.options.permissionCollection,
            widget: this.options.widget,
            editable: this.options.editable,
            movable: this.options.movable,
            cloneable: this.options.cloneable,
            deletable: this.options.deletable
        }));

        this.$el.attr('data-widget-id', this.options.widget.get('id'));
        return this;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/reports/widgets/textwidget/TextWidgetView.ts